import { OfferOrderUrlConstant } from 'src/constants';
import {
  OfferOrderDetailsDto,
  CreateOfferOrderCardPaymentIntentDto,
  CreateOfferOrderCardPaymentIntentResponseDto,
  UpdateOfferOrderCardPaymentIntentDto,
  UpdateOfferOrderCardPaymentIntentResponseDto,
  CreateOfferOrderDto,
  GetOfferOrderListDto,
  GetOfferOrderDto,
  UpdateOfferOrderDto,
  GetOfferOrderListResponseDto,
  CancelOfferOrderDto,
  FailOfferOrderDto,
  CompleteOfferOrderDto,
} from 'src/dtos';
import { WithAuthToken } from 'src/utils';

import { replacePlaceholders } from '../sagas/utils';
import { httpRequest } from '../utils/httpRequest';

export class OfferOrderApi {
  async create({ params, body, authToken }: WithAuthToken<CreateOfferOrderDto>): Promise<OfferOrderDetailsDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.LIST, params);

    return httpRequest<OfferOrderDetailsDto>({
      method: 'POST',
      url,
      body,
      authToken,
    });
  }

  async list({
    authToken,
    params,
    queryParams,
  }: WithAuthToken<GetOfferOrderListDto>): Promise<GetOfferOrderListResponseDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.LIST, params);

    return httpRequest<GetOfferOrderListResponseDto>({
      method: 'GET',
      url,
      authToken,
      queryParams,
    });
  }

  async retrieve({ params, authToken }: WithAuthToken<GetOfferOrderDto>): Promise<OfferOrderDetailsDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.RETRIEVE, params);

    return httpRequest<OfferOrderDetailsDto>({
      method: 'GET',
      url,
      authToken,
    });
  }

  async update({ params, body, authToken }: WithAuthToken<UpdateOfferOrderDto>): Promise<OfferOrderDetailsDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.UPDATE, params);

    return httpRequest<OfferOrderDetailsDto>({
      method: 'PUT',
      url,
      body,
      authToken,
    });
  }

  async cancel({ params, authToken }: WithAuthToken<CancelOfferOrderDto>): Promise<OfferOrderDetailsDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.CANCEL, params);

    return httpRequest<OfferOrderDetailsDto>({
      method: 'PUT',
      url,
      authToken,
    });
  }

  async fail({ params, authToken }: WithAuthToken<FailOfferOrderDto>): Promise<OfferOrderDetailsDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.FAIL, params);

    return httpRequest<OfferOrderDetailsDto>({
      method: 'PUT',
      url,
      authToken,
    });
  }

  async complete({ params, authToken }: WithAuthToken<CompleteOfferOrderDto>): Promise<OfferOrderDetailsDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.COMPLETE, params);

    return httpRequest<OfferOrderDetailsDto>({
      method: 'PUT',
      url,
      authToken,
    });
  }

  async createCardPaymentIntent({
    body,
    authToken,
  }: WithAuthToken<CreateOfferOrderCardPaymentIntentDto>): Promise<CreateOfferOrderCardPaymentIntentResponseDto> {
    return httpRequest<CreateOfferOrderCardPaymentIntentResponseDto>({
      method: 'POST',
      url: OfferOrderUrlConstant.CREATE_CARD_PAYMENT_INTENT,
      body,
      authToken,
    });
  }

  async updateCardPaymentIntent({
    params,
    body,
    authToken,
  }: WithAuthToken<UpdateOfferOrderCardPaymentIntentDto>): Promise<UpdateOfferOrderCardPaymentIntentResponseDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.UPDATE_CARD_PAYMENT_INTENT, params);

    return httpRequest<UpdateOfferOrderCardPaymentIntentResponseDto>({
      method: 'PUT',
      url,
      body,
      authToken,
    });
  }
}
